<template>
  <ModalCardDefault title="Gerar Relatório" @close="close">
    <ExpansionPanel
      v-model="panel"
      title="Informações do Relatório"
      :icon="$icons.box"
      readonly
    >
      <Row class="mt-2">
        <Col>
          <h2 class="mb-2">Relatório {{ item.name }}</h2>
          <span class="red--text"
            >Ao clicar no botão "Gerar" o relatório começará a ser preparado,
            assim que finalizarmos você receberá um e-mail com o link do
            relatório.</span
          >
        </Col>
      </Row>
      <Row class="mt-2">
        <Col>
          <Select
              v-model="format"
              placeholder="Selecione o formato"
              label="Formato"
              :items="[{ text: 'PDF', value: 'pdf' }, { text: 'CSV', value: 'csv' }]"
            />
        </Col>
      </Row>
    </ExpansionPanel>

    <div slot="actions">
      <Button
        label="Gerar"
        @click="generateReport"
        class="mr-3"
        rounded
        color="secondary"
        :loading="loadingGenerate"
      />
    </div>
  </ModalCardDefault>
</template>

<script>
import ModalCardDefault from '@/components/ModalCardDefault';
import { ExpansionPanel, Row, Col, Button, Select } from '@/components/vuetify';
export default {
  name: 'FinishBalance',
  components: {
    ModalCardDefault,
    ExpansionPanel,
    Row,
    Col,
    Button,
    Select,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      panel: [0],
      resetProductNotChanged: false,
      loadingGenerate: false,
      format: 'pdf',
    };
  },
  methods: {
    generateReport() {
      this.loadingGenerate = true;

      this.$api.reports
        .generateReport(this.item.id, this.format)
        .then(() => {
          this.$noty.success('Relatório gerado com sucesso!');
        })
        .catch(() => {
          this.$noty.error('Erro ao gerar relatório!');
        })
        .finally(() => {
          this.loadingGenerate = false;
          this.$emit('close');
        });
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>
